import {
  Button,
  Card,
  CardContent,
  CardMedia, CircularProgress,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import userItemStyle from "./userItemStyle";
import Box from "@material-ui/core/Box";
import { Delete as DeleteIcon, VpnKey as KeyIcon } from "@material-ui/icons";
import PlaceholderImage from "../../assets/user.png"
import { notifySuccess } from "../../utils/js/helpers";
import { COLORS } from "../../utils/js/constants";

const useStyles = makeStyles((theme) => userItemStyle(theme));

const UserItem = ({ resetPassword, user, removeUserById }) => {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => setLoading(false), [user])

  const loadingElement = () => (<>
    <span>Aguarde </span>
    <CircularProgress style={{color: COLORS.white}} size={12} />
  </>)

  return (
    <Card className={classes.card}>
      <CardMedia
        className={classes.cover}
        image={PlaceholderImage}
        title="user image"
      />

      <CardContent className={classes.content}>
        <List
          component="nav"
          aria-label="main mailbox folders"
          className={classes.list}
        >
          <ListItem className={classes.listItem}>
            <ListItemText
              primary="Nome: "
              secondary={user.displayName}
              className={classes.listItem}
            />
          </ListItem>

          <ListItem className={classes.listItem}>
            <ListItemText
              primary="Código: "
              secondary={user.email}
              className={classes.listItem}
            />
          </ListItem>
        </List>
      </CardContent>

      <Box className={classes.actions}>
        <Button
          className={`${classes.button} ${classes.redBtn}`}
          variant="contained"
          startIcon={<DeleteIcon />}
          onClick={() => {
            setLoading(true)
            removeUserById(user.uid)
          }}
          disabled={loading}
        >
          { loading ? loadingElement() : "Remover" }
        </Button>

        <Button
          className={`${classes.button} ${classes.yellowBtn}`}
          variant="contained"
          startIcon={<KeyIcon />}
          onClick={() => {
            resetPassword(user.email)
            notifySuccess("Um link de recuperação de senha foi enviado para o usuário!")
          }}
        >
          Redefinir Senha
        </Button>
      </Box>
    </Card>
  );
};

export default UserItem;
